import { getEntitlementsSection } from './entitlements';
import { useProductBuilderMode } from './productBuilderMode';

export const STANDARD_RECORD_FIELD = 'is_standard';

export const isEntitlementEnabled = (value) =>
  value === true || value === 'true' || value === 1 || value === '1';

/** True when record row or detail payload has is_standard = true. */
export function isStandardRecord(row) {
  if (!row) return false;
  if (row.is_standard === true || row.isStandard === true) return true;
  if (row.is_standard === false || row.isStandard === false) return false;
  const nested = row.is_standard;
  if (nested && typeof nested === 'object') {
    const v = nested.value ?? nested.displayValue;
    return v === true || v === 'true' || v === 1 || v === '1';
  }
  return false;
}

export function extractIsStandardFromRecordData(recordData) {
  if (!recordData) return false;
  if (recordData.is_standard_record === true) return true;
  if (recordData.is_standard_record === false) return false;

  const sections = [
    ...(Array.isArray(recordData.highlightSection) ? recordData.highlightSection : []),
    ...(Array.isArray(recordData.details)
      ? recordData.details.flatMap((section) => section?.fields || [])
      : []),
    ...(Array.isArray(recordData.otherHiddenFields) ? recordData.otherHiddenFields : []),
  ];
  const field = sections.find(
    (f) =>
      String(f?.fieldName || f?.field_name || '').toLowerCase() === STANDARD_RECORD_FIELD
  );
  if (!field) return false;
  const v = field.value ?? field.displayValue;
  return v === true || v === 'true' || v === 1 || v === '1';
}

/** Same gate as ObjectManager / LayoutManager / FieldManager. */
export function getStandardRecordAccessFromEntitlements(productBuilderMode = false) {
  const objectManagerConfig = getEntitlementsSection('objectManager', {});
  const enableStandardObject =
    isEntitlementEnabled(objectManagerConfig?.enable_standard) ||
    isEntitlementEnabled(objectManagerConfig?.enableStandard);
  return {
    enableStandardObject,
    productBuilderMode: productBuilderMode === true,
  };
}

export function canMutateStandardRecord(access = {}) {
  const { enableStandardObject = false, productBuilderMode = false } = access;
  return enableStandardObject === true || productBuilderMode === true;
}

export function canEditStandardRecord(recordData, access) {
  if (recordData?.canEditRecord === false) return false;
  if (recordData?.canEditRecord === true) return true;
  const isStandard = extractIsStandardFromRecordData(recordData);
  if (!isStandard) return true;
  return canMutateStandardRecord(access);
}

export function canDeleteStandardRecord(recordData, access) {
  if (recordData?.canDeleteRecord === false) return false;
  if (recordData?.canDeleteRecord === true) return true;
  const isStandard = extractIsStandardFromRecordData(recordData);
  if (!isStandard) return true;
  return canMutateStandardRecord(access);
}

export function useStandardRecordAccess() {
  const productBuilderMode = useProductBuilderMode();
  return getStandardRecordAccessFromEntitlements(productBuilderMode);
}

/** Show record is_standard on layouts when Enable Standard / Product Builder (FieldManager pattern). */
export function canManageStandardRecordFlag(productBuilderMode = false) {
  const access = getStandardRecordAccessFromEntitlements(productBuilderMode);
  return canMutateStandardRecord(access);
}
